import { getObject, remove, RepositoryKey, setObject } from "utils/repository";

export function getSessionId(): string | null {
    return getObject(RepositoryKey.AI_AGENT_SESSION_ID);
}

export function setSessionId(sessionId: string): void {
    setObject(RepositoryKey.AI_AGENT_SESSION_ID, sessionId);
}

export function clear(): void {
    remove(RepositoryKey.AI_AGENT_SESSION_ID);
}
